import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import Button from '@atlaskit/button/standard-button';
import EmptyState from '@atlaskit/empty-state';
import { ButtonClickedEvent, useAnalyticsEvents } from '@atlassian/mpac-analytics';
import React from 'react';
import { ANALYTICS_SUBJECT_ID_EMPTY_VIEW_APPLY_PROMOTION } from '../../../../../../analytics/Events';
import promotionsEmptyView from '../../../../../../images/promotions-empty-view.svg';
import { jsx as _jsx } from "react/jsx-runtime";
const PromotionsEmptyView = props => {
  const fireAnalyticsEvent = useAnalyticsEvents();
  const onPrimaryActionClick = () => {
    fireAnalyticsEvent({
      eventType: ButtonClickedEvent,
      actionSubjectId: ANALYTICS_SUBJECT_ID_EMPTY_VIEW_APPLY_PROMOTION
    });
    props.onApplyPromotionsBtnClick();
  };
  const primaryAction = /*#__PURE__*/_jsx(Button, {
    appearance: "primary",
    onClick: onPrimaryActionClick,
    children: "Apply promotion codes"
  });
  const EmptyStateprops = {
    header: 'No promotions applied yet',
    description: "Got a promotion code from a Marketplace partner? Apply it here to get discounts on installed apps.",
    imageUrl: promotionsEmptyView,
    primaryAction
  };
  return /*#__PURE__*/_jsx(EmptyState, _objectSpread({}, EmptyStateprops));
};
export default PromotionsEmptyView;